<div class="headerdiv">
  <h1>Miles Configuration</h1>
</div>
<div class="card-body">
  <div class="row">
    <div class="col-md-12">
      <div class="form-div">
        <div class="row">
          <div class="m-portlet">
            <div>
              <div>
                <div class="form-div">
                  <label> &nbsp;&nbsp; &nbsp;&nbsp; Type Of Journey</label>
                </div>
                <div class="col-lg-3">
                  <select (change)="miles_data($event.target.value)" class="form-control m-input"
                    [(ngModel)]="selectedValue">
                    <option value="" selected> Select </option>
                    <option value="Domestic"> Domestic </option>
                    <option value="International"> International </option>
                  </select>
                </div>
                <button class="btn btn-primary commonbutt" type="button" (click)=" downloadSample()">
                  Download Sample
                </button>
                <input type="file" style="display: inline-block;" (change)="incomingfile($event)" accept=".xlsx">
                <button type="button" class="btn btn-success commonbutt" (click)="Upload()">
                  <em class="fa fa-upload"></em>&nbsp;&nbsp;
                  <span class="bold">Upload</span>

                </button>

                <div id="loder_div" style="display:none;text-align: center">
                  <h3>file uploaded successfully </h3>
                </div>

                <div *ngIf="loader">
                  <div style="margin:auto; text-align: center">
                    <img
                      src="https://vignette.wikia.nocookie.net/lego/images/b/b4/Loading_Animation.gif/revision/latest/scale-to-width-down/480?cb=20120528032206"
                      width="8%" height="8%" alt="Loader" />
                  </div>
                </div>
                <br>
                <br>
                <table aria-describedby="milesConfigurationData" class="table table-striped" style="margin-top: 20px;
                    margin-left: 15px;
                    width: 1101px;">
                  <tr *ngFor="let tpmkey of tpm_m_key">
                    <th scope="col">{{tpmkey.TPM_START_RANGE}}</th>
                    <th scope="col">{{tpmkey.TPM_END_RANGE}}</th>
                    <th scope="col">{{tpmkey.JP_MIN_MILES }}</th>
                    <th scope="col">{{tpmkey.JP_MAX_MILES}}</th>
                  </tr>

                  <tr *ngFor="let tabledata of all_data">
                    <td *ngIf="tabledata.TPM_START_RANGE!=10001">{{tabledata.TPM_START_RANGE}}</td>
                    <td *ngIf="tabledata.TPM_START_RANGE==10001">Others</td>
                    <td *ngIf="tabledata.TPM_END_RANGE!=10005">{{tabledata.TPM_END_RANGE}}</td>
                    <td *ngIf="tabledata.TPM_END_RANGE==10005"></td>
                    <td>{{tabledata.JP_MIN_MILES}}</td>
                    <td>{{tabledata.JP_MAX_MILES}}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>